<script lang="ts">
    import { _ } from "svelte-i18n";
    import { appManager } from "../AppManagerStore";
    import Countup from "../components/Countup.svelte";

    let annual: boolean = true;
    let individual: number = 100;
    let team: number = 500;
    let premium: number = 2000;
</script>

<section class="py-7">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-8 text-center">
                <h1 class="display-3">
                    {$_("pricing.plans.title1")} <br />
                    <span class="font-weight-bold text-primary-desat"
                        >{$_("pricing.plans.title2")}</span>
                </h1>

                <p class="fs-lg text-muted mb-4 mb-md-4">
                    {$_("pricing.plans.subtitle")}
                </p>

                <form
                    class="d-flex align-items-center justify-content-center mb-7 mb-md-9 text-muted">
                    <span>{$_("pricing.plans.monthly")}</span>

                    <div class="form-check form-switch mx-3">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            bind:checked={annual} />
                    </div>
                    <span>{$_("pricing.plans.annual")}</span>
                </form>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-12 col-md-4">
                <div class="card shadow-lg mb-6 mb-md-0">
                    <div class="card-body">
                        <div class="text-center mb-3">
                            <span
                                class="badge badge-pill badge-primary-desat-soft">
                                <span class="h6 text-uppercase"
                                    >{$_("pricing.plans.trial.title")}</span>
                            </span>
                        </div>

                        <div class="d-flex justify-content-center">
                            <span class="h2 mb-0 mt-2">€</span>
                            <span class="price display-2 mb-0">0</span>
                            <span class="h2 align-self-end mb-1" />
                        </div>

                        <p class="text-center text-muted mb-5">{$_("pricing.plans.trial.subtitle")}</p>

                        <div class="d-flex">
                            <!-- Badge -->
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.trial.check1")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.trial.check2")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.trial.check3")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.trial.check4")}</p>
                        </div>

                        <div class="d-grid gap-2 mt-3">
                            <a
                                class="btn btn-block btn-primary"
                                href="{$appManager.PublicUrl}signup">
                                {$_("pricing.plans.trial.start")}
                                <i class="fe fe-arrow-right ml-3" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4">
                <div class="card shadow-lg mb-md-0">
                    <div class="card-body">
                        <div class="text-center mb-3">
                            <span
                                class="badge badge-pill badge-primary-desat-soft">
                                <span class="h6 text-uppercase"
                                    >{$_(
                                        "pricing.plans.individual.title"
                                    )}</span>
                            </span>
                        </div>

                        <div class="d-flex justify-content-center">
                            <span class="h2 mb-0 mt-2">€</span>
                            <span class="price display-2 mb-0"
                                ><Countup
                                    value={annual
                                        ? individual * 0.9
                                        : individual}
                                    initial={individual * 0.9} /></span>
                            <span class="h2 align-self-end mb-1"
                                >{$_("general.permonth")}</span>
                        </div>

                        <p class="text-center text-muted mb-5">
                            {$_("pricing.plans.individual.subtitle")}
                        </p>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.individual.check1")}</p>
                        </div>
                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.individual.check2")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.individual.check3")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.individual.check4")}</p>
                        </div>
                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.individual.check5")}</p>
                        </div>

                        <div class="d-grid gap-2 mt-3">
                            <a
                                class="btn btn-block btn-primary"
                                href="{$appManager.PublicUrl}buy?plan=individual&yearly={annual}">
                                {$_("pricing.plans.individual.start")}
                                <i class="fe fe-arrow-right ml-3" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4">
                <div class="card shadow-lg mb-md-0">
                    <div class="card-body">
                        <div class="text-center mb-3">
                            <span
                                class="badge badge-pill badge-primary-desat-soft">
                                <span class="h6 text-uppercase"
                                    >{$_("pricing.plans.team.title")}</span>
                            </span>
                        </div>

                        <div class="d-flex justify-content-center">
                            <span class="h2 mb-0 mt-2">€</span>
                            <span class="price display-2 mb-0"
                                ><Countup
                                value={annual
                                    ? team * 0.9
                                    : team}
                                initial={team * 0.9} step={5}/></span>
                            <span class="h2 align-self-end mb-1"
                                >{$_("general.permonth")}</span>
                        </div>

                        <p class="text-center text-muted mb-5">
                            {$_("pricing.plans.team.subtitle")}
                        </p>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.team.check1")}</p>
                        </div>
                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.team.check2")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.team.check3")}</p>
                        </div>

                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.team.check4")}</p>
                        </div>
                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.team.check5")}</p>
                        </div>
                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.team.check6")}</p>
                        </div>
                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle badge-success-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p>{$_("pricing.plans.team.check7")}</p>
                        </div>

                        <div class="d-grid gap-2 mt-3">
                            <a
                                class="btn btn-block btn-primary"
                                href="{$appManager.PublicUrl}buy?plan=team&yearly={annual}">
                                {$_("pricing.plans.team.start")}
                                <i class="fe fe-arrow-right ml-3" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8 text-center">
                    <!-- 
                <p class="fs-lg text-muted mb-7 mb-md-9">
                    It is our mission to help you work more efficiently and to be smarter than your competition. Using ANYWAYS should be a win for you and our pricing is set accordingly.
                </p> -->
                    <!-- 
                        <p class="fs-lg text-muted mb-7 mb-md-9">
                            You can use our trial to explore what ANYWAYS can do. Have you seen the light, then the team plan is for you, and you can use ANYWAYS as much as you like. If you prefer to work on a project-by-project basis the individual plan is perfect for you. We made it easy for you to include us in your offer to your own clients for a fixed price. 
                        </p> -->
                    <p class="fs-lg text-muted mt-6 mb-2 mb-md-4">
                        {$_("pricing.plans.custom1")}
                        <a
                            class="text-primary-desat"
                            href="{$appManager.PublicUrl}contact"
                            >{$_("pricing.plans.custom2")}</a
                        >.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
